import { API_ROUTES } from '../constants/api'
import {
  NOTIFICATION_LIST_LIMIT,
  type InboxNotification,
} from '../constants/notifications'
import { api } from './api-client'
import { mapInboxNotification } from './overview'
import { withQuery } from './orders'

function toRows(raw: unknown): Record<string, unknown>[] {
  if (Array.isArray(raw)) return raw as Record<string, unknown>[]
  if (raw && typeof raw === 'object') {
    const record = raw as { data?: unknown; items?: unknown }
    if (Array.isArray(record.data)) return record.data as Record<string, unknown>[]
    if (Array.isArray(record.items)) return record.items as Record<string, unknown>[]
  }
  return []
}

export async function fetchNotifications(
  limit = NOTIFICATION_LIST_LIMIT,
): Promise<InboxNotification[]> {
  const raw = await api.get<unknown>(
    withQuery(API_ROUTES.notifications, { limit }),
  )
  return toRows(raw)
    .map((row) => mapInboxNotification(row))
    .filter((row): row is InboxNotification => row !== null)
}

export async function fetchUnreadNotificationCount(): Promise<number> {
  const raw = await api.get<unknown>(API_ROUTES.notificationsUnread)
  if (raw && typeof raw === 'object' && 'count' in raw) {
    const count = Number((raw as { count: unknown }).count)
    return Number.isFinite(count) ? count : 0
  }
  return 0
}

export async function markNotificationRead(id: string): Promise<InboxNotification | null> {
  const raw = await api.patch<unknown>(API_ROUTES.notificationRead(id), {})
  if (!raw || typeof raw !== 'object') return null
  return mapInboxNotification(raw as Record<string, unknown>)
}

export async function markAllNotificationsRead(): Promise<void> {
  await api.patch(API_ROUTES.notificationsReadAll, {})
}
